<template>
  <div class="chart-grid"><slot/></div>
</template>
<script setup></script>